export default class LinkAnchorEnum {
    static LINK_TRIGGER = '[data-trigger="wpet-link-anchor"]'
    static SECTION_ELEMENT = '.wp-block-wp-etourisme-v3-section'
}
